export var displayName = 'field';
export var defaultProps = {
  name: '',
  children: function children() {
    return null;
  },
  'data-id': displayName,
  touched: false,
  width: '100%',
  height: 'auto',
  value: '',
  onBlur: function onBlur(event) {
    return event;
  },
  onChange: function onChange(event) {
    return event;
  },
  onFocus: function onFocus(event) {
    return event;
  },
  stateReducer: function stateReducer(_ref) {
    var type = _ref.type,
        currentState = _ref.currentState,
        changes = _ref.changes;
    return {
      type: type,
      currentState: currentState,
      changes: changes
    };
  }
};
export var initialState = function initialState(props) {
  return {
    dirty: false,
    pristine: true,
    floatAbove: false,
    // true if this field currently has focus. It will only work if you are passing
    // onFocus to your input element.
    active: false,
    touched: false,
    visited: false,
    xClickLast: 0,
    initial: props.value ? props.value : '',
    internalValue: '',
    controlledValue: '',
    error: props.error
  };
};
export var internalStateReducer = function internalStateReducer(_ref2) {
  var type = _ref2.type,
      currentState = _ref2.currentState,
      changes = _ref2.changes;
  return {
    type: type,
    currentState: currentState,
    changes: changes
  };
};